import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Button, Nav } from 'react-bootstrap';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Profile from 'components/UserBox/Profile';
import LeftMenus from 'components/UserBox/LeftMenus';
import useAuthStore, { resetState, setUserInfo } from 'store/auth';
import { logoutZIM, useLogoutMutation } from 'services';
import toast from 'react-hot-toast';
import './styles.scss';
import { isMobileOnly } from 'react-device-detect';
import { disconnect } from 'store/socket';
import useTranslate from 'hooks/useTranslate';
import { USER_TYPES } from 'constants/index';
import { resetFeeds } from 'store/feeds';
import { resetAllStores } from 'store/resetStore';
import { clearStorageExceptPrefix } from 'utils';
import { secureStorage } from 'utils/secureStorage';

const Sidebar: React.FC<any> = ({ showModal, onClose }) => {
	const { translate } = useTranslate();
	const user: any = useAuthStore((state) => state.userInfo.user);
	const navigate = useNavigate();
	// mutation
	const { mutateAsync: logoutMutation } = useLogoutMutation();

	const handleSelect = (value: string | null) => {
		if (value) {
			navigate(value);
		}
	};

	const handleLogout = () => {
		onClose();
		logoutMutation().then((res: any) => {
			resetFeeds();
			clearStorageExceptPrefix(sessionStorage, ['uc_']);
			clearStorageExceptPrefix(localStorage, ['uc_', 'i18nextLng']);
			resetAllStores();
			if (res?.statusCode === 401) {
				secureStorage.removeItem('fcmToken');
				logoutZIM();
				disconnect();
				resetState();
			}

			if (res?.success) {
				secureStorage.removeItem('fcmToken');
				logoutZIM();
				disconnect();
				setUserInfo({});
				toast.success(res?.message);
			}
		});
	};

	return (
		<div className="sidebar-menus">
			<Offcanvas show={showModal} onHide={() => onClose()}>
				<div className="user-box white-box bg-white position-relative">
					<Button
						className="sidebar-close-btn position-absolute border-0"
						onClick={() => onClose()}
					>
						<i className="ri-arrow-right-s-line"></i>
					</Button>
					<Stack className="user text-center">
						<Profile onClose={onClose} />
						<hr className="m-0"></hr>
						<Nav>
							<Nav.Item>
								<Nav.Link
									className="user-actions-menu border-0 d-flex align-items-center gap-2"
									onClick={() => {
										navigate('/');
										onClose();
									}}
								>
									<i className="ri-home-line"></i>
									{translate('Sidebar.home')}
								</Nav.Link>
							</Nav.Item>

							{isMobileOnly && user?.userType === 'company' && (
								<Nav.Item>
									<Nav.Link
										className="user-actions-menu border-0 d-flex align-items-center gap-2"
										onClick={() => {
											navigate('/company/post-new-job');
											onClose();
										}}
									>
										<i className="ri-home-line"></i>
										{translate('Sidebar.postAJob')}
									</Nav.Link>
								</Nav.Item>
							)}
							{user?.userType === 'company' && (
								<Nav.Item>
									<Nav.Link
										className="user-actions-menu border-0 d-flex align-items-center gap-2"
										onClick={() => {
											navigate('/company/my-jobs');
											onClose();
										}}
									>
										<i className="ri-briefcase-3-line"></i>
										{translate('Sidebar.jobs')}
									</Nav.Link>
								</Nav.Item>
							)}
							<Nav.Item>
								<Nav.Link
									className="user-actions-menu border-0 d-flex align-items-center gap-2"
									onClick={() => {
										navigate('/social-feed-posts');
										onClose();
									}}
								>
									<i className="ri-draft-line"></i>
									{translate('Sidebar.feeds')}
								</Nav.Link>
							</Nav.Item>
							{user?.userType === USER_TYPES?.COMPANY && (
								<Nav.Item>
									<Nav.Link
										className="user-actions-menu border-0 d-flex align-items-center gap-2"
										onClick={() => {
											navigate('/company/subscriptions');
											onClose();
										}}
									>
										<i className="ri-vip-crown-line"></i>
										{translate('Sidebar.plans')}
									</Nav.Link>
								</Nav.Item>
							)}
						</Nav>
						<hr className="m-0"></hr>
						<Nav
							variant="tabs"
							defaultActiveKey="/my-Preferences"
							className="user-actions border-0 flex-column text-start"
							onSelect={handleSelect}
						>
							<LeftMenus onClose={onClose} />
							<Nav.Item>
								<Nav.Link
									className="user-actions-menu border-0 d-flex align-items-center gap-2 logout-btn"
									onClick={() => handleLogout()}
								>
									<i className="ri-logout-circle-r-line"></i> {translate('Sidebar.logout')}
								</Nav.Link>
							</Nav.Item>
						</Nav>
					</Stack>
				</div>
			</Offcanvas>
		</div>
	);
};

export default Sidebar;
